// extracted by mini-css-extract-plugin
export default {"zoomModal":"J4-z","image":"K4-z","button":"L4-z","isOverlayShown":"M4-z"};